import { useEffect, useSyncExternalStore } from 'react';
import { quickReplyStore } from '../models/quickReplyStore';
export function useQuickReplies(channel, enabled=true) {
 const state=useSyncExternalStore(quickReplyStore.subscribe,()=>quickReplyStore.snapshot(channel));
 useEffect(()=>{if(enabled)quickReplyStore.load(channel).catch(()=>{});},[channel,enabled]);
 return {...state,reload:()=>quickReplyStore.load(channel,true).catch(()=>{})};
}
